import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { RequestsForm } from '@modules/requests/my-requests/myRequestsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { ActionBar } from '@modules/requests/my-requests/myRequestsGridButtons';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const myRequestsUrl = '/metropolis/api/owa/employee/requests/own';
export const myRequestsLabel = 'Moje žádosti';
export const myRequestsPath = '/warehouses/my-requests';
export const myRequestsGridName = 'myRequestsGrid';

const filters = [{ field: 'requestState.id', operation: 'EQ', value: 'WAITING' }];

export const MyRequestsGrid = compose(
  withRouter,
  setDisplayName(myRequestsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: myRequestsLabel }]),
  withColumns(Agenda.MY_REQUESTS),
  withProps(({ columns }) => ({
    name: myRequestsGridName,
    url: myRequestsUrl,
    Form: RequestsForm,
    dialog: false,
    gridProps: {
      columns,
      filters,
      defaultFilter: filters,
      filterRow: true,
      showCheckboxes: true,
      deleting: false,
      filtering: true,
      locale: 'cz',
      adding: false,
      ActionBar,
      pageSize: 50,
      version: 3
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/requests/my-requests/myRequestsGrid.tsx